import React, { useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";

const API_URL = "https://api.ricgop.online/api/v1/company";
const TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTQ0MCwiZW1haWwiOiJpbmZvQHJpY2dvcC5vbmxpbmUiLCJuYW1lIjoiTXIgV2Vic2l0ZSIsImlhdCI6MTc2NjQ2ODI1Nn0.xjOAl33RTZCkiqDrPeRE1E_ruLlpFaCQjEF7CMKfCsY";

const EMPTY_FORM = {
  name: "",
  department: "",
  medicineName: "",
  address: "",
  phone: "",
  email: "",
  website: "",
  cell: "",
  user1: { name: "", cnic: "", cellNumber: "", userName: "", email: "" },
  user2: { name: "", cnic: "", cellNumber: "", userName: "", email: "" },
};
const SUPPLIER_TYPES = [
  "Medicine",
  "Surgical / Disposables",
  "Technical",
  "IT / Software",
  "Maintenance",
  "Machinery / Equipment",
  "Civil Works",
  "General / Miscellaneous",
];

const RegisterCompany = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
  const [saving, setSaving] = useState(false);
  const [registered, setRegistered] = useState(null); // { companyCode, name, department }
  const [copied, setCopied] = useState(false);

  const handleChange = (e, userKey = null) => {
    const { name, value } = e.target;

    if (userKey) {
      setFormData({
        ...formData,
        [userKey]: { ...formData[userKey], [name]: value },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const showSnackbar = (message, type = "success") => {
    setSnackbar({ open: true, message, type });
    setTimeout(() => {
      setSnackbar({ open: false, message: "", type });
    }, 3000);
  };

  const isUser2PartiallyFilled = () => {
    const { name, cnic, cellNumber, userName, email } = formData.user2;
    return name || cnic || cellNumber || userName || email;
  };

  const handleCopy = () => {
    if (!registered?.companyCode) return;
    navigator.clipboard.writeText(registered.companyCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    const { user1, user2 } = formData;

    if (!formData.department.trim()) {
      showSnackbar("❌ Department is required", "error");
      setSaving(false);
      return;
    }

    if (!formData.supplierType) {
      showSnackbar("❌ Type of Supplier is required", "error");
      setSaving(false);
      return;
    }

    if (!user1.name || !user1.cnic || !user1.cellNumber || !user1.userName || !user1.email) {
      showSnackbar("❌ All fields of Authorized User 1 are required", "error");
      setSaving(false);
      return;
    }

    if (isUser2PartiallyFilled()) {
      if (!user2.name || !user2.cnic || !user2.cellNumber || !user2.userName || !user2.email) {
        showSnackbar("❌ Please complete all fields of Authorized User 2 or leave all empty", "error");
        setSaving(false);
        return;
      }
    }

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        showSnackbar(data.message || "An error occurred", "error");
        setSaving(false);
        return;
      }

      showSnackbar("✅ Company Registered Successfully", "success");

      setRegistered({
        companyCode: data.companyCode || data.company?.companyCode,
        name: formData.name,
        department: formData.department,
      });

      setFormData(EMPTY_FORM);
      e.target.reset();
    } catch (err) {
      console.error(err);
      showSnackbar("An unexpected error occurred", "error");
    }
    setSaving(false);
  };

  return (
    <main>
      <Breadcrumb title="Register Your Company" />

      {snackbar.open && (
        <div
          style={{
            position: "fixed",
            top: 20,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: snackbar.type === "success" ? "#4caf50" : "#f44336",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            zIndex: 9999,
            transition: "all 0.3s ease-in-out",
          }}
        >
          {snackbar.message}
        </div>
      )}

      <section className="py-5" style={{ backgroundColor: "#f9fbfc" }}>
        <div className="container">
          {registered ? (
            /* ---------- Success / Registration ID panel ---------- */
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="card border-0 shadow-sm rounded-4 text-center p-5">
                  <div style={{ fontSize: "3rem", lineHeight: 1 }}>✅</div>
                  <h3 className="fw-bold mt-3 mb-1">Registration Successful</h3>
                  <p className="text-muted mb-4">
                    {registered.name} &mdash; {registered.department}
                  </p>

                  <p className="text-uppercase text-muted mb-2" style={{ letterSpacing: "1px", fontSize: ".8rem" }}>
                    Your Registration ID
                  </p>
                  <div
                    className="mx-auto mb-3 px-4 py-3 rounded-3"
                    style={{
                      backgroundColor: "#f1f5f9",
                      border: "1px dashed #94a3b8",
                      display: "inline-block",
                      fontSize: "1.75rem",
                      fontWeight: 700,
                      letterSpacing: "2px",
                      color: "#0f172a",
                    }}
                  >
                    {registered.companyCode || "—"}
                  </div>

                  <div>
                    <button type="button" className="btn btn-outline-secondary rounded-pill px-4 me-2" onClick={handleCopy}>
                      {copied ? "Copied!" : "Copy ID"}
                    </button>
                    <button type="button" className="btn btn-danger rounded-pill px-4" onClick={() => setRegistered(null)}>
                      Register Another Department
                    </button>
                  </div>

                  <p className="text-muted small mt-4 mb-0">
                    Please save this ID — it will be required for all future correspondence and login support.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            /* ---------- Registration form ---------- */
            <>
              <h2 className="text-center mb-5 text-dark fw-bold display-5">🏢 Company Registration</h2>
              <div>
                <h4 className="text-center mb-5 text-dark">
                  For Login Please{" "}
                  <a href="https://app.ricgop.online" style={{ color: "red", textDecoration: "none" }}>
                    Click Here
                  </a>
                </h4>
              </div>
              <br />

              <form onSubmit={handleSubmit}>
                {/* Company Info */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                  <div className="card-header bg-transparent p-4">
                    <h5 className="fw-semibold text-primary mb-0">📄 Company Information</h5>
                  </div>
                  <div className="card-body p-4">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Company Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Department"
                          name="department"
                          value={formData.department}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Medicine Name"
                          name="medicineName"
                          value={formData.medicineName}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <select className="form-select" name="supplierType" value={formData.supplierType} onChange={handleChange} required>
                          <option value="">Select Type of Supplier</option>
                          {SUPPLIER_TYPES.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input className="form-control" placeholder="Cell" name="cell" value={formData.cell} onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Website"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <small className="text-muted d-block mt-3">
                      An already-registered company can register again under a different department. Each registration gets its own unique ID.
                    </small>
                  </div>
                </div>

                {/* User 1 */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                  <div className="card-header bg-transparent p-4">
                    <h5 className="fw-semibold text-primary mb-0">👤 Authorized User 1</h5>
                  </div>
                  <div className="card-body p-4">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Name"
                          name="name"
                          value={formData.user1.name}
                          onChange={(e) => handleChange(e, "user1")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Username"
                          name="userName"
                          value={formData.user1.userName}
                          onChange={(e) => handleChange(e, "user1")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="CNIC"
                          name="cnic"
                          value={formData.user1.cnic}
                          onChange={(e) => handleChange(e, "user1")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Cell Number"
                          name="cellNumber"
                          value={formData.user1.cellNumber}
                          onChange={(e) => handleChange(e, "user1")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Email"
                          name="email"
                          value={formData.user1.email}
                          onChange={(e) => handleChange(e, "user1")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* User 2 */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                  <div className="card-header bg-transparent p-4">
                    <h5 className="fw-semibold text-primary mb-0">👤 Authorized User 2</h5>
                  </div>
                  <div className="card-body p-4">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Name"
                          name="name"
                          value={formData.user2.name}
                          onChange={(e) => handleChange(e, "user2")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Username"
                          name="userName"
                          value={formData.user2.userName}
                          onChange={(e) => handleChange(e, "user2")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="CNIC"
                          name="cnic"
                          value={formData.user2.cnic}
                          onChange={(e) => handleChange(e, "user2")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Cell Number"
                          name="cellNumber"
                          value={formData.user2.cellNumber}
                          onChange={(e) => handleChange(e, "user2")}
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          className="form-control"
                          placeholder="Email"
                          name="email"
                          value={formData.user2.email}
                          onChange={(e) => handleChange(e, "user2")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-danger rounded-pill px-5 py-3" disabled={saving}>
                    {saving ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit Registration"
                    )}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </section>
    </main>
  );
};

export default RegisterCompany;
